export default "__VITE_ASSET__$BeYn7K1__"